export const SITE = {
  name: "Pondok Pesantren Al-Khoir",
  shortName: "Al-Khoir",
  serviceName: "Sistem Informasi Keuangan Al-Khoir",
  email: "pesantren@alkhoir.id",
  phone: "+62 811-6251-414",
  phoneRaw: "628116251414",
  waName: "Ummi Imah",
  address:
    "Desa Mananti Sosa Jae, Kecamatan Huta Raja Tinggi, Kabupaten Padang Lawas, Provinsi Sumatera Utara, Kode Pos 22776",
  mapUrl: "https://maps.app.goo.gl/P3iejv5erK1otqor7",
  social: {
    facebook: "https://facebook.com/pesantrenalkhoir",
    instagram: "https://www.instagram.com/pesantrenalkhoir",
    tiktok: "https://www.tiktok.com/@pesantrenalkhoir",
    tiktok2: "https://www.tiktok.com/@btsdailysantri",
    youtube: "https://www.youtube.com/@PesantrenAlKhoir",
  },
};
